(function (angular) {
    angular.module('app').directive('scroll', ['$window', function ($window) {
        return function (scope, element, attrs) {
            angular.element($window).bind("mousewheel onmousewheel touchmove", function (event) {
                if ($('body').hasClass('mobile') && $('body').hasClass('keyboardOpen')) {
                    var elements = 'input[type="text"],input[type="password"],input[type="date"],input[type="number"],input[type="email"],select,textarea';
                    $(elements).blur();
                }
            });
        };
    }]);
})(angular);